import { QueryClient } from '@tanstack/react-query';

export const browserClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: window.Cypress ? false : 3
        }
    }
});
